import axios from "../api";

export const listTransactionDataAction = async (perPage, page, searchValue, startDate, endDate, statusFilter, amountFilter, tenantFilter) => {
  let apiUrl = `/api/transaction?page=${page}&pageSize=${perPage}&status=${statusFilter}`;
  if (amountFilter) {
    apiUrl += `&amount=${amountFilter}`;
  }

  if (searchValue !== "all") {
    searchValue = searchValue.trim();
    apiUrl += `&searchValue=${searchValue}`;
  }

  if (startDate && endDate) {
    apiUrl += `&startDate=${startDate}&endDate=${endDate}`;
  }

  if (tenantFilter !== "all") {
    apiUrl += `&tenantFilter=${tenantFilter}`;
  }

  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const exportTransactionHistoryAction = (data) => {
  return new Promise((resolve, reject) => {
    let url = "/api/transaction/export";
    axios
      .post(url, data, {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


export const getTransactionSummaryAction = async (filters = {}) => {
  let apiUrl = `/api/transaction/summary?`;

  const params = new URLSearchParams();

  if (filters.startDate) {
    params.append('startDate', filters.startDate);
  }

  if (filters.endDate) {
    params.append('endDate', filters.endDate);
  }

  if (filters.status && filters.status !== "all") {
    params.append('status', filters.status);
  }

  if (filters.tenantFilter && filters.tenantFilter !== "all") {
    params.append('tenantFilter', filters.tenantFilter);
  }

  if (filters.searchValue && filters.searchValue !== "all" && filters.searchValue.trim()) {
    params.append('searchValue', filters.searchValue.trim());
  }

  if (filters.amount && filters.amount !== "all") {
    params.append('amount', filters.amount);
  }
  apiUrl += params.toString();
  return new Promise((resolve, reject) => {
    axios
      .get(apiUrl)
      .then((response) => {
        resolve(response.data?.data || {});
      })
      .catch((error) => {
        reject(error);
      });
  });
};
